import React from 'react'
import ReactPlayer from 'react-player/lazy'
import { Button, Header, Icon, Modal ,Grid, Segment, FormComponente} from 'semantic-ui-react';
import  ManageModuloForm from '../modulo/ManageModuloModalForm';
import  ManageContenidoModalForm from '../contenido/ManageContenidoModalForm';

const ModalFormulario = ({showModal, closeModal,modulo, idTipoContenido, datos={}, titulo, tipoFormulario, idCurso, idModulo, contenidoView, cargarModulos, idModuloActivo, cargarContenido}) => (
  <Modal open={showModal}  size='large'>
    <Header icon="wordpress forms" content={titulo} />
    <Modal.Content>
     
        <div>  
        {tipoFormulario==1?
    
            <ManageModuloForm
                closeModal={closeModal}    
                idCurso={idCurso}
                idModulo={idModulo}
                cargarModulos={cargarModulos}
    
            />
    
        :""}
    </div>
     
    <div>    
        {tipoFormulario==2?
     
            <ManageContenidoModalForm
                closeModal={closeModal}
                idModuloContenido={idModulo}
                contenidoView={contenidoView}
                idContenido ={modulo.idContenido}
                idModuloActivo={idModuloActivo}
                cargarContenido={cargarContenido}
            />
        :""}
        </div>    
    
    </Modal.Content>
    <Modal.Actions>
      <Button basic color='gray' onClick={closeModal} >
         regresar
      </Button>
       
    </Modal.Actions>
  </Modal>
)

export default ModalFormulario;